import Swal from "sweetalert2";
import { t } from "i18next";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { debugLogActions, debugErrorActions } from "../helpers/debugHelper";

const handleFlowAssignmentError = (body, dispatch) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
  }
  if (body.code === "bak-aut-tok-inv-001") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
    dispatch(startLogout());
  }
};

export const startLoadingFlowRoleCiiuAssignments = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.FLOW_ROLE_CIIU_ASSIGNMENT_START_LOADING, payload: true });

    try {
      const query = new URLSearchParams(filters).toString();
      const endpoint = query ? `get?${query}` : "get";

      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_FLOW_ROLE_CIIU_ASSIGNMENT}`,
        endpoint
      );
      const body = await resp.json();

      debugLogActions(":: flowRoleCiiuAssignmentActions, startLoadingFlowRoleCiiuAssignments", body);

      if (body.ok) {
        dispatch({
          type: types.FLOW_ROLE_CIIU_ASSIGNMENT_SET,
          payload: body.flowRoleCiiuAssignments || []
        });
      } else {
        handleFlowAssignmentError(body, dispatch);
      }
    } catch (error) {
      debugErrorActions(":: flowRoleCiiuAssignmentActions, startLoadingFlowRoleCiiuAssignments", error);
    } finally {
      dispatch({ type: types.FLOW_ROLE_CIIU_ASSIGNMENT_START_LOADING, payload: false });
    }
  };
};

export const startRegisterFlowRoleCiiuAssignment = (data) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_FLOW_ROLE_CIIU_ASSIGNMENT}`,
        "add",
        data,
        "POST"
      );
      const body = await resp.json();

      debugLogActions(":: flowRoleCiiuAssignmentActions, startRegisterFlowRoleCiiuAssignment", body);

      if (body.ok) {
        dispatch(startLoadingFlowRoleCiiuAssignments());
        return body.flowRoleCiiuAssignment;
      }

      handleFlowAssignmentError(body, dispatch);
      return null;
    } catch (error) {
      debugErrorActions(":: flowRoleCiiuAssignmentActions, startRegisterFlowRoleCiiuAssignment", error);
      return null;
    }
  };
};

export const startUpdateFlowRoleCiiuAssignment = (id, data) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_FLOW_ROLE_CIIU_ASSIGNMENT}`,
        `update/${id}`,
        data,
        "PUT"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(startLoadingFlowRoleCiiuAssignments());
        return body.flowRoleCiiuAssignment;
      }

      handleFlowAssignmentError(body, dispatch);
      return null;
    } catch (error) {
      debugErrorActions(":: flowRoleCiiuAssignmentActions, startUpdateFlowRoleCiiuAssignment", error);
      return null;
    }
  };
};

export const startDeleteFlowRoleCiiuAssignment = (id) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_FLOW_ROLE_CIIU_ASSIGNMENT}`,
        `delete/${id}`,
        {},
        "DELETE"
      );
      const body = await resp.json();

      if (body.ok) {
        dispatch(startLoadingFlowRoleCiiuAssignments());
        return true;
      }

      handleFlowAssignmentError(body, dispatch);
      return false;
    } catch (error) {
      debugErrorActions(":: flowRoleCiiuAssignmentActions, startDeleteFlowRoleCiiuAssignment", error);
      return false;
    }
  };
};
